import { ReactNode } from "react";

// Login page uses a standalone layout without the main app navigation
export default [];